import {useState} from "react";
import {useTranslation} from "react-i18next";

function Page3({ sim, setSim, goToQuestion, goNext }) {
    const [popup, setPopup] = useState(false)
    const { t, i18n } = useTranslation();

    const _goToQuestion = (idx) => {
        if(!sim.timeRunning)
            return

        goToQuestion(idx)
    }

    const openPopup = () => {
        setPopup(true)
    }

    const closePopup = () => {
        setPopup(false)
    }

    return (
        <div className="exam-sim-page-7">
            <div className="exam-sim-row">
                <div className="exam-sim-col">
                    <h3>{t('sim.page3.title')}</h3>
                    <p>
                        {t('sim.page3.text1')}
                    </p>
                    <div>
                        <button type="button" className="btn" onClick={openPopup}>{t('sim.page3.next')}</button>
                    </div>
                    <ul className="exam-sim-grid-legend">
                        <li className="missing"><span>{t('sim.page3.missing')}</span></li>
                        <li className="answered"><span>{t('sim.page3.answered')}</span></li>
                        <li className="marked"><span>{t('sim.page3.marked')}</span></li>
                    </ul>
                    {sim.timeRunning ? <p>
                        {t('sim.page3.text2')}
                    </p> : <p>
                        {t('sim.page3.text3')}
                    </p>}
                </div>
                <div className="exam-sim-col exam-sim-right">
                    <ul className="exam-sim-question-grid-items">
                        {sim.currentQuestions.map((q, idx) => {
                            let classes = []
                            if(q.marked)
                                classes.push('marked')
                            if(q.answer === null || q.answer?.length === 0)
                                classes.push('missing')
                            // if(q.is_correct === true)
                            //     classes.push('correct')
                            if(!sim.timeRunning)
                                classes.push('disabled')
                            return <li key={idx} className={classes.join(' ')}>
                                <button type="button" onClick={() => _goToQuestion(idx)}>{idx + 1}</button>
                            </li>
                        })}
                    </ul>
                </div>
            </div>
            <div className="exam-sim-popup" style={{ display: popup ? 'flex' : 'none'}}>
                <div className="exam-sim-popup-dialog">
                    <h4>{t('sim.page3.nextTitle')}</h4>
                    <p>{t('sim.page3.nextText')}</p>
                    <div className="exam-sim-popup-buttons">
                        <button type="button" className="btn secondary" onClick={goNext}>{t('yes')}</button>
                        <button type="button" className="btn" onClick={closePopup}>{t('no')}</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Page3;
